import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { registerServiceWorker } from './pwa/register';
import './index.css';

/* Fail loudly if the one mount point is missing, rather than rendering into nothing. */
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('the #root element is missing from index.html');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/*
 * Register the offline worker in production only. In development it would sit between Vite and the
 * page and serve a stale shell against the HMR the dev server is trying to push — so dev stays
 * uncached, and the worker (and its config message, from the app once the manifest is read) is a
 * production concern.
 */
/* Registration can be refused — a private window, a policy, an unsupported browser. The app
   works without it, so there is nothing to say and nothing left unheld. */
if (import.meta.env.PROD) registerServiceWorker().catch(() => {});
